import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "df" }

import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAppStore } from '@/shared/config/storeConfig/storeConfig'


export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    blackColor: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	blackColor?: boolean
};

const MAX_WIDTH = 500



const store = useAppStore()
const route = useRoute()
const breadcrumbs = computed(() => store.state.breadcrumbs.breadcrumbsList)

const isActive = (item) => {
	return item.path ? item.path === route.path : item.name === breadcrumbs.value[breadcrumbs.value.length - 1].name
}

const initStyles = () => {
	if (breadcrumbs.value.length > 1) {
		const list = document.querySelectorAll('.el-breadcrumb__item')

		list.forEach(item => {
			const el = item.querySelector('a')

			if (el.offsetWidth > MAX_WIDTH) {
				item.classList.add('is-too-big')
			}
		})
	} else {
		setTimeout(initStyles, 100)
	}
}

onMounted(initStyles)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createBlock(_component_el_breadcrumb, {
    separator: "|",
    class: _normalizeClass([{'black': props.blackColor}, "breadcrumbs"]),
    style: _normalizeStyle(`--max-width: ${MAX_WIDTH}px`)
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbs), (item, i) => {
        return (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: item.path + i,
          class: _normalizeClass({'active': isActive(item)})
        }, {
          default: _withCtx(() => [
            (item.dropdown)
              ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, {
                      "data-testid": `breadcrumb-dropdown-${i + 1}`
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.dropdown, (drop) => {
                          return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                            key: drop.path,
                            class: "breadcrumbs__dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_router_link, {
                                to: drop.path
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(drop.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["data-testid"])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, [
                      _createVNode(_component_router_link, {
                        to: item.path || _ctx.$route.fullPath,
                        style: _normalizeStyle(!props.blackColor && `color: white`)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "style"]),
                      _createVNode(_component_el_icon, {
                        class: "el-icon--right",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", {
                            style: _normalizeStyle(props.blackColor && `color: var(--main-text-color)`),
                            class: "material-icons-round"
                          }, "expand_more", 4)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  style: _normalizeStyle(!props.blackColor && `color: white`),
                  to: item.path || ''
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["style", "to"]))
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["class", "style"]))
}
}

})